import { Sidebar, Menu, MenuItem, SubMenu } from "react-pro-sidebar";
import React, { useState, useContext, useEffect } from "react";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "./confirmationModal.css";
import {
  AiOutlineArrowLeft,
  AiOutlinePrinter,
  AiOutlineSave,
  AiOutlineBars,
  AiOutlineCheck,
  AiOutlineClose,
  AiOutlineFileAdd,
  AiOutlineDelete,
  AiOutlineCalculator,
  AiOutlineFileText,
  AiOutlineUser,
  AiOutlineLogout,
} from "react-icons/ai";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import addNewValuation from "../methods/api/addNewValuation";
import updateValuation from "../methods/api/updateValuation";
import { useReactToPrint } from "react-to-print";
import { ValuationDataContext } from "../contextProviders/ValuationDataProvider";
import { ValuationsListContext } from "../contextProviders/ValuationsListProvider";
import "./sidebar.css";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { TailSpin } from "react-loader-spinner";
import { Routes, Route } from "react-router-dom";
import deleteValuation from "../methods/api/deleteValuation";
import { confirmAlert } from "react-confirm-alert";
import listValuations from "../methods/api/listValuations";
import logoCITT from "../media/Logo_CITT.png";
import logout from "../methods/api/logout";
import useValutationData from "../hooks/useValutationData";

const theme = createTheme({
  palette: {
    primary: {
      main: "#183557",
    },
  },
});

const SideBar = ({ refs, authenticated, user }) => {
  // const { valuationData } = useContext(ValuationDataContext);
  const {valuationData, setValuationData, calculateSensitivityAnalysis, calculateNPVtoDiscountRate, isLoading} = useValutationData();
  const { setValuationsList, setFilteredValuationsList } = useContext(
    ValuationsListContext
  );

  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [saveIcon, setSaveIcon] = useState(<AiOutlineSave />);
  const [deleteIcon, setDeleteIcon] = useState(<AiOutlineDelete />);
  const [addNewIcon, setAddNewIcon] = useState(<AiOutlineFileAdd />);
  const [logoutIcon, setLogoutIcon] = useState(<AiOutlineLogout />);
  const [currentTab, setCurrentTab] = useState("wycena");
  const navigate = useNavigate();
  const location = useLocation();

  const onScrollToRef = (ref) => {
    ref.current.scrollIntoView({ behavior: "smooth" });
  };
  const handlePrint = useReactToPrint({
    content: () => refs.printRef?.current,
  });
  const toggleSidebar = (isOpen) => {
    setSidebarOpen(isOpen);
  };
  const handleSave = async () => {
    setSaveIcon(<TailSpin height={16} color="black" />);

    updateValuation(valuationData).then((status) => {
      if (status === 200) {
        setSaveIcon(<AiOutlineCheck className="fade-out" color="green" />);
      } else {
        setSaveIcon(<AiOutlineClose className="fade-out" color="red" />);
      }
      setTimeout(() => setSaveIcon(<AiOutlineSave />), 2000);
    });
  };
  const handleAddNewValuation = () => {
    addNewValuation().then((status) => {
      if (status === 201) {
        setAddNewIcon(<AiOutlineCheck className="fade-out" color="green" />);
        listValuations().then((response) => {
          setValuationsList(response);
          setFilteredValuationsList(response);
        });
      } else {
        setAddNewIcon(<AiOutlineClose className="fade-out" color="red" />);
      }
      setTimeout(() => setAddNewIcon(<AiOutlineFileAdd />), 2000);
    });
  };
  const handleDelete = () => {
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div className="confirmation-modal-backdrop">
            <div className="confirmation-modal-content">
              <h1 className="modal-title">Usunąć wycenę?</h1>
              <p className="modal-message">Ta operacja jest nieodwracalna</p>
              <div className="modal-buttons">
                <button
                  className="modal-button modal-button-no"
                  onClick={onClose}
                >
                  NIE
                </button>
                <button
                  className="modal-button modal-button-yes"
                  onClick={() => {
                    deleteValuation(valuationData.indeks).then((status) => {
                      if (status === 200) {
                        setDeleteIcon(
                          <AiOutlineCheck className="fade-out" color="green" />
                        );
                        navigate("/wyceny");
                      } else {
                        setDeleteIcon(
                          <AiOutlineClose className="fade-out" color="red" />
                        );
                      }
                      setTimeout(
                        () => setDeleteIcon(<AiOutlineDelete />),
                        2000
                      );
                    });
                    onClose();
                  }}
                >
                  TAK
                </button>
              </div>
            </div>
          </div>
        );
      },
    });
  };
  const handleLogout = () => {
    logout().then((status) => {
      if (status === 200) {
        setLogoutIcon(<AiOutlineCheck className="fade-out" color="green" />);
        window.localStorage.removeItem("token");
        window.location.href = "/login";
      } else {
        setLogoutIcon(<AiOutlineClose className="fade-out" color="red" />);
      }
      setTimeout(() => setLogoutIcon(<AiOutlineLogout />), 2000);
    });
  };

  useEffect(() => {
    setCurrentTab(location.pathname === "/wyceny/arkusz" ? "arkusz" : "wycena");
  }, [location]);

  return (
    <ThemeProvider theme={theme}>
      <Routes>
        <Route
          path="/wyceny"
          element={
            <Sidebar
              rootStyles={{ position: "fixed", width: "300px" }}
              className="sidebar"
              collapsed={!sidebarOpen}
              onMouseEnter={() => toggleSidebar(true)}
              onMouseLeave={() => toggleSidebar(false)}
            >
              <Menu
                menuItemStyles={{
                  root: {
                    background: "rgb(249, 249, 249, 0.7)",
                    cursor: "pointer",
                    "& *": { cursor: "pointer" },
                  },
                }}
              >
                <MenuItem
                  icon={
                    <img
                      src={logoCITT}
                      style={{ width: "20px", height: "20px" }}
                    />
                  }
                  component={<Link to="/moje_dane" />}
                >
                  Witaj, {user.username}
                </MenuItem>
                <MenuItem icon={logoutIcon} onClick={handleLogout}>
                  WYLOGUJ
                </MenuItem>
                <MenuItem icon={addNewIcon} onClick={handleAddNewValuation}>
                  NOWA WYCENA
                </MenuItem>
                {user.role === "admin" ? (
                  <MenuItem
                    icon={<AiOutlineUser />}
                    component={<Link to="/uzytkownicy" />}
                  >
                    ZARZĄDZAJ UŻYTKOWNIKAMI
                  </MenuItem>
                ) : null}
              </Menu>
            </Sidebar>
          }
        />
        <Route
          path="/uzytkownicy"
          element={
            <Sidebar
              rootStyles={{ position: "fixed", width: "300px" }}
              className="sidebar"
              collapsed={!sidebarOpen}
              onMouseEnter={() => toggleSidebar(true)}
              onMouseLeave={() => toggleSidebar(false)}
            >
              <Menu
                menuItemStyles={{
                  root: {
                    background: "rgb(249, 249, 249, 0.7)",
                    cursor: "pointer",
                    "& *": { cursor: "pointer" },
                  },
                }}
              >
                <MenuItem
                  icon={
                    <img
                      src={logoCITT}
                      style={{ width: "20px", height: "20px" }}
                    />
                  }
                  component={<Link to="/moje_dane" />}
                >
                  Witaj, {user.username}
                </MenuItem>
                <MenuItem
                  className="menu-item"
                  icon={<AiOutlineArrowLeft />}
                  component={<Link to="/wyceny" />}
                  id="return-button"
                >
                  POWRÓT
                </MenuItem>
              </Menu>
            </Sidebar>
          }
        />
        <Route
          path="/moje_dane"
          element={
            <Sidebar
              rootStyles={{ position: "fixed", width: "300px" }}
              className="sidebar"
              collapsed={!sidebarOpen}
              onMouseEnter={() => toggleSidebar(true)}
              onMouseLeave={() => toggleSidebar(false)}
            >
              <Menu
                menuItemStyles={{
                  root: {
                    background: "rgb(249, 249, 249, 0.7)",
                    cursor: "pointer",
                    "& *": { cursor: "pointer" },
                  },
                }}
              >
                <MenuItem
                  icon={
                    <img
                      src={logoCITT}
                      style={{ width: "20px", height: "20px" }}
                    />
                  }
                  component={<Link to="/moje_dane" />}
                >
                  Witaj, {user.username}
                </MenuItem>
                <MenuItem
                  className="menu-item"
                  icon={<AiOutlineArrowLeft />}
                  component={<Link to="/wyceny" />}
                  id="return-button"
                >
                  POWRÓT
                </MenuItem>
              </Menu>
            </Sidebar>
          }
        />
        <Route
          path="/wyceny/wycena"
          element={
            <Sidebar
              rootStyles={{ position: "fixed", width: "300px" }}
              className="sidebar"
              collapsed={!sidebarOpen}
              onMouseEnter={() => toggleSidebar(true)}
              onMouseLeave={() => toggleSidebar(false)}
            >
              <Menu
                menuItemStyles={{
                  root: {
                    background: "rgb(249, 249, 249, 0.7)",
                    cursor: "pointer",
                    "& *": { cursor: "pointer" },
                  },
                }}
              >
                <MenuItem
                  icon={
                    <img
                      src={logoCITT}
                      style={{ width: "20px", height: "20px" }}
                    />
                  }
                  component={<Link to="/moje_dane" />}
                >
                  Witaj, {user.username}
                </MenuItem>
                <MenuItem
                  className="menu-item"
                  icon={<AiOutlineArrowLeft />}
                  component={<Link to="/wyceny" />}
                  id="return-button"
                >
                  POWRÓT
                </MenuItem>
                <MenuItem className="menu-item" icon={<AiOutlineCalculator />}>
                  <Tabs value={currentTab}>
                    <Tab
                      value="wycena"
                      label="WYCENA"
                      to={`/wyceny/wycena?${new URLSearchParams(
                        location.search
                      )}`}
                      component={Link}
                      onClick={() => {
                        setCurrentTab("wycena");
                      }}
                    />
                    <Tab
                      value="arkusz"
                      label="ARKUSZ"
                      to={`/wyceny/arkusz?${new URLSearchParams(
                        location.search
                      )}`}
                      component={Link}
                      onClick={() => {
                        setCurrentTab("arkusz");
                      }}
                    />
                  </Tabs>
                </MenuItem>
                <MenuItem
                  className="menu-item"
                  onClick={handleSave}
                  icon={saveIcon}
                >
                  ZAPISZ
                </MenuItem>
                <MenuItem
                  className="menu-item"
                  onClick={handleDelete}
                  icon={deleteIcon}
                  disabled={user.role !== "admin"}
                >
                  USUŃ
                </MenuItem>
                <MenuItem
                  className="menu-item"
                  icon={<AiOutlinePrinter />}
                  onClick={handlePrint}
                >
                  DRUKUJ / PDF
                </MenuItem>
                <SubMenu
                  defaultOpen={false}
                  icon={<AiOutlineBars />}
                  label="SEKCJE"
                >
                  <MenuItem
                    className="menu-item"
                    icon={"1"}
                    onClick={() => {
                      onScrollToRef(refs.basicDataRef);
                    }}
                  >
                    Dane podstawowe
                  </MenuItem>
                  <MenuItem
                    className="menu-item"
                    icon={"2"}
                    onClick={() => {
                      onScrollToRef(refs.assumptionsRef);
                    }}
                  >
                    Założenia ogólne
                  </MenuItem>
                  <MenuItem
                      className="menu-item"
                      icon={"3"}
                      onClick={() => {
                        onScrollToRef(refs.valuationBasisRef);
                      }}
                  >
                    Podsumowanie wykonawcze
                  </MenuItem>
                  <MenuItem
                    className="menu-item"
                    icon={"4"}
                    onClick={() => {
                      onScrollToRef(refs.assumptionsAdvancedRef);
                    }}
                  >
                    Założenia szczegółowe
                  </MenuItem>
                  <MenuItem
                    className="menu-item"
                    icon={"5"}
                    onClick={() => {
                      onScrollToRef(refs.analyticsRef);
                    }}
                  >
                    Założenia analityczne
                  </MenuItem>
                  <MenuItem
                    className="menu-item"
                    icon={"6"}
                    onClick={() => {
                      onScrollToRef(refs.financialRef);
                    }}
                  >
                    Założenia finasowe
                  </MenuItem>
                  <MenuItem
                    className="menu-item"
                    icon={"7"}
                    onClick={() => {
                      onScrollToRef(refs.calculationsRef);
                    }}
                  >
                    Wyliczenia końcowe
                  </MenuItem>
                </SubMenu>
                {sidebarOpen && <Calendar className="calendar" />}
              </Menu>
            </Sidebar>
          }
        />
        <Route
          path="/wyceny/arkusz"
          element={
            <Sidebar
              rootStyles={{ position: "fixed", width: "300px" }}
              className="sidebar"
              collapsed={!sidebarOpen}
              onMouseEnter={() => toggleSidebar(true)}
              onMouseLeave={() => toggleSidebar(false)}
            >
              <Menu
                menuItemStyles={{
                  root: {
                    background: "rgb(249, 249, 249, 0.7)",
                    cursor: "pointer",
                    "& *": { cursor: "pointer" },
                  },
                }}
              >
                <MenuItem
                  icon={
                    <img
                      src={logoCITT}
                      style={{ width: "20px", height: "20px" }}
                    />
                  }
                  component={<Link to="/moje_dane" />}
                >
                  Witaj, {user.username}
                </MenuItem>
                <MenuItem
                  className="menu-item"
                  icon={<AiOutlineArrowLeft />}
                  component={<Link to="/wyceny" />}
                  id="return-button"
                >
                  POWRÓT
                </MenuItem>
                <MenuItem className="menu-item" icon={<AiOutlineFileText />}>
                  <Tabs value={currentTab}>
                    <Tab
                      value="wycena"
                      label="WYCENA"
                      to={`/wyceny/wycena?${new URLSearchParams(
                        location.search
                      )}`}
                      component={Link}
                      onClick={() => {
                        setCurrentTab("wycena");
                      }}
                    />
                    <Tab
                      value="arkusz"
                      label="ARKUSZ"
                      to={`/wyceny/arkusz?${new URLSearchParams(
                        location.search
                      )}`}
                      component={Link}
                      onClick={() => {
                        setCurrentTab("arkusz");
                      }}
                    />
                  </Tabs>
                </MenuItem>
                <MenuItem
                  className="menu-item"
                  onClick={handleSave}
                  icon={saveIcon}
                >
                  ZAPISZ
                </MenuItem>
                <MenuItem
                  className="menu-item"
                  onClick={handleDelete}
                  icon={deleteIcon}
                  disabled={user.role !== "admin"}
                  rootStyles={{label: {background: "red"}}}
                >
                  USUŃ
                </MenuItem>
                <MenuItem
                  className="menu-item"
                  icon={<AiOutlinePrinter />}
                  onClick={handlePrint}
                >
                  DRUKUJ / PDF
                </MenuItem>
                {sidebarOpen && <Calendar className="calendar" />}
              </Menu>
            </Sidebar>
          }
        />
      </Routes>
    </ThemeProvider>
  );
};

export default SideBar;
